import { render, staticRenderFns } from "./managecar.vue?vue&type=template&id=3d70e148&scoped=true"
import script from "./managecar.vue?vue&type=script&lang=js"
export * from "./managecar.vue?vue&type=script&lang=js"
import style0 from "./managecar.vue?vue&type=style&index=0&id=3d70e148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70e148",
  null
  
)

export default component.exports